import { render } from "./SitesIdPage.vue?vue&type=template&id=0ca1176c"
import script from "./SitesIdPage.vue?vue&type=script&lang=js"
export * from "./SitesIdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__